/* eslint-disable no-console */
/* eslint-disable no-underscore-dangle */
import { Wrap } from './styles';

import Layer from 'services/models/Layer';
import geoAlert from 'services/utils/alert';
import geoConfirm from 'services/utils/confirm';
import Coord from 'services/utils/Coordinate';
import { getCurrentDate } from 'services/utils/date';
import { measureArea, measureLength } from 'services/utils/measures';

import geoBahiaLogoPrint from './imgs/geobahia-logo-print.png';
import inemaLogoPrint from './imgs/inema-logo-print.png';

// import { bodyXmlIntersectionFeatureCollection } from 'views/MapView/services/wpsHelper.js';

/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
// import axios from 'axios';
/**
 * Importação do componente ReportRestrictionAreasLoader, responsavel
 * por carregar um gif enquanto o relatório está sendo gerado
 */
import ReportRestrictionAreasLoader from 'components/ReportRestrictionAreasLoader';
import domtoimagemore from "dom-to-image-more";
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap, é uma biblioteca de mapeamento 
 * leve e de codigo aberto, utiliza um banco de dados geografico editável gratuito.
 */
import L from 'leaflet';
import LeafletMiniMap from 'leaflet-minimap';
/**
 * useEffect é um hook que permite executar efeitos colaterais em seus componentes, por exemplo:
 * buscar dados, atualizar diretamente o DOM e cronômetros, ele aceita dois argumentos o segundo
 * é opcional.
 *
 * useState é um hook que nos permite rastrear o estado em um componente de função, o estado
 * geralmente se refere a dados ou propriedads que precisam ser rastreador em um aplicativo.
 *
 * useRef permite que persista valores entre renderizações, ele pode ser usado para armazenar
 * um valor mutável que não causa uma nova renderização quando atualizado e pode ser usado para
 * acessar diretamente um elemento do DOM.
 *
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 *
 * useMemo é um hook que retorna um valor memorizado.
 */
import { useState, useEffect, useCallback } from 'react';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';
/**
 * Função responsável por abertura do modal para importar arquivos
 *
 * @param {boolean} onClose Fechar o modal
 * @returns Retorna o carregamento do projeto importado e fecha o modal depois.
 */
export const ProtectedAreasReportView = (
  { 
    dataProtectedAreasReport,
    activeReport, 
    subtitle, 
    comment, 
    setMapReport, 
    inputLayer, 
    setIntersectionsRestrictionAreas,
    intersectionsRestrictionAreas,
    setErrorCrossingLayers,
    errorCrossingLayers,
    infoLayer,
    onClose 
  }) => {  
  const { map, basemaps } = useMap();
  const maxInitialHeightMapPrint = 640;
  const [maxHeightImg, setMaxHeightImg] = useState(maxInitialHeightMapPrint);
  const maxInitialWidthMapPrint = 680;
  const [maxWidthImg, setMaxWidthImg] = useState(maxInitialWidthMapPrint);  
  const [crossingIsRunning, setCrossingIsRunning] = useState(false);
  const [loading, setLoading] = useState(false);  
  const [startPrint, setStartPrint] = useState(false);

  


  /**
   * Adiciona cabeçalho
   */
  const addHeader = useCallback((doc) => {    
    // Título do relatório   
    doc.setTextColor("#3C71DD");
    doc.setFont(undefined, 'bold');
    doc.text('Relatório Preliminar de Análise Ambiental', 36, 30);   
    doc.setTextColor("#5E5E5E");  
    doc.setFont(undefined, 'normal');
    doc.addImage(geoBahiaLogoPrint, "JPEG", 467, 22, 0, 0, '', 'NONE');
    doc.addImage(inemaLogoPrint, "JPEG", 523, 21, 0, 0, '', 'NONE');
    doc.line(36, 34, 555, 34);
    doc.setFontSize(12);    
    doc.text(subtitle, 36, 44);    
    doc.setFontSize(10);
    doc.text("Bahia, " + getCurrentDate(), 494, 44);

    Promise.resolve('Hello')
  }, [subtitle]);

  /**
   * Adiciona comentário
   */
  const addComment = useCallback((doc) => {
    doc.text(comment, 36, 70, {
      maxWidth: 517
    });
  }, [comment]);

  /**
   * Obtem imagem do "Mapa de Localiazação" a partir do preview
   */
  const getImageMapLocation = useCallback(() => {    
    return domtoimagemore.toPng(
      document.getElementById('map-location-report'),
      { 
        width: 553,
        height: 264,
        cacheBust: true
      }
    );      
  }, []);

  /**
   * Redimensiona imagem em base64
   */
  const resizeImage = useCallback((base64Str, maxWidth = 450, maxHeight = 300, proportion = null) => {    
    return new Promise((resolve) => {
      let img = new Image();
      img.src = base64Str;
      img.onload = () => {        
        let canvas = document.createElement('canvas');        
        let ctx = canvas.getContext('2d');  
        if (proportion) {
          maxWidth = img.width + (proportion * img.width);
          maxHeight = img.height + (proportion * img.height);
        }      
        canvas.width = maxWidth;
        canvas.height = maxHeight;        
        ctx.drawImage(img, 0, 0, maxWidth, maxHeight);

        resolve({
          image: canvas.toDataURL("image/png", 1.0),
          imageWidth: img.width
        })
      }
    })
  }, []);

  /**
   * Adiciona sessão "Mapa de Localização"
   */
  const addMapLocation = useCallback((doc, mapImageLocation) => {   

    // Adiciona informações sobre a camada de entrada
    const addInfoInputLayer = () => {
      doc.saveGraphicsState();

      doc.setGState(new doc.GState({
        opacity: 0.1,         
      }));
      doc.setDrawColor('#ffffff');
      doc.setFillColor('#3C71DD');      
      doc.roundedRect(36, 390, 520, 15, 1, 1, "FD");    
      
      doc.restoreGraphicsState();

      doc.text(infoLayer.geometryType.toUpperCase(), 45, 400);       

      if (inputLayer.dataType === 'Polygon' || inputLayer.dataType === 'Geometry') {        
        doc.text(infoLayer.dataInfo[0][0] + ':' , 100, 400);
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(infoLayer.dataInfo[0][1], 118, 401);
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(infoLayer.dataInfo[1][0] + ':', 200, 400);
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(infoLayer.dataInfo[1][1], 237, 401);
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
      } else if (inputLayer.dataType === 'LineString') {        
        doc.text(infoLayer.dataInfo[0][0] + ':', 100, 400);
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');        
        doc.text(infoLayer.dataInfo[0][1], 144, 401);
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
      } else {        
        doc.text(infoLayer.dataInfo[0][0] + ':', 100, 400);
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(infoLayer.dataInfo[0][1], 128, 401);
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
        doc.text(infoLayer.dataInfo[1][0] + ':', 180, 400);
        doc.setFontSize(12);
        doc.setFont(undefined, 'bold');
        doc.text(infoLayer.dataInfo[1][1], 217, 401);
        doc.setFontSize(10);
        doc.setFont(undefined, 'normal');
      }
    };

    doc.setFontSize(14);
    doc.setTextColor('#3C71DD');    
    doc.text('Mapa de Localização', 36, 120);    
    doc.setDrawColor('#3C71DD');
    doc.line(36, 124, 200, 124);  
    
    doc.setFontSize(9);
    doc.setTextColor("#5E5E5E");

    doc.addImage(mapImageLocation.image, "PNG", 36, 134, 0, 0, 'imageMapLocation', 'SLOW');

    addInfoInputLayer()
    
  }, [infoLayer, inputLayer]);

  /**
   * Obtém imagem da escala gráfica do mapa do preview
   */
  const getImageScale = () => {    
    let elScaleMap = document.getElementsByClassName("scale")[1];       
    return domtoimagemore.toPng(
      elScaleMap, 
      {                       
        height: elScaleMap.offsetHeight,
        width: elScaleMap.offsetWidth,
      }
    );
  };

  /**
   * Adiciona imagem da escala sobre o mapa
   */
  const buildScaleMap = useCallback((doc, imageScaleMap) => {    
    // Conta MALUCA para alinhar imagem da escala gráfica manualemnte 
    // a direita, já que não foi possível realizar com auxílio do JsPdf.
    let xAjust = imageScaleMap.imageWidth > 130
                  ? 0
                  : 130 - imageScaleMap.imageWidth
    let initXImageMap = 422 + xAjust;
    let initYImageMap = 354;
    doc.addImage(imageScaleMap.image, "PNG", initXImageMap, initYImageMap, 0, 0, '', 'NONE'); 
  }, []);
  
  /**
   * Adiciona cartão de cruzamento
   */
  const addAlertCrossings = useCallback((doc) => {    
    const PAGE_HEIGHT = 800; // Altura total da folha
    const MARGIN = 35; // Margem para cada lado
    const CARDS_PER_LINE = 4; // Número de cards por linha
    const cardWidth = 132; // Largura do card
    const cardHeight = 64; // Altura do card
  
    // Adiciona cabeçalho da seção "Cruzamentos de Alerta"
    const addAlertCrossingHeader = () => {
      doc.setFontSize(14);
      doc.setTextColor('#3C71DD');    
      doc.text('Cruzamentos de Alerta', 36, currentYHeightCursor);    
      doc.setDrawColor('#3C71DD');
      doc.line(36, currentYHeightCursor + 4, 200, currentYHeightCursor + 4);  
      
      doc.setFontSize(9);
      doc.setTextColor("#5E5E5E");
    };

    // Desenha caixa onde serão apresentadas informações do cruzamento
    const drawCardBox = (positionX, positionY) => {
      doc.saveGraphicsState();

      doc.setGState(new doc.GState({
        opacity: 0.1,         
      }));
      doc.setDrawColor('#ffffff');
      doc.setFillColor('#3C71DD');         
      doc.roundedRect(positionX, positionY, 125, 64, 1, 1, "FD");
      
      doc.restoreGraphicsState();
    };  

    // Adiciona título (nome da camada Àrea de Restrição) no box
    const addTitleBox = (title, positionX, positionY) => {
      doc.text(title, positionX, positionY, {
        maxWidth: cardWidth - 26,
        align: 'center'
      }); 
    };
  
    // Adicionar valor de interseção centralizado dentro do card
    const addValueOfIntersection = (valueIntersection, positionX, positionY) => {
      doc.setFontSize(16); // Fonte para o valor
      doc.setFont(undefined, 'bold');
      doc.text(valueIntersection, positionX, positionY, {
        maxWidth: cardWidth - 20, // Margem interna
        align: 'center' // Centralizar
      });
      doc.setFont(undefined, 'normal');
      doc.setFontSize(9); // Retornar ao tamanho normal
    };

    // Adiciona o card do alerta de cruzamento
    const addCardAlertCrossing = (ira, positionAttCard) => {
      // Desenha retângulos
      drawCardBox(positionAttCard.positionRectCardX, positionAttCard.positionRectCardY);
      // Adiciona título
      addTitleBox(ira.aliasLayer, positionAttCard.positionInfoCardX, positionAttCard.positionTitleCardY);
      // Adiciona valor da interseção
      addValueOfIntersection(ira.valueIntersection, positionAttCard.positionInfoCardX, positionAttCard.positionAreaHaCardY);
    };

    // Inicializar posição e atributos do card
    let currentYHeightCursor = 440; // Posição inicial do cursor
    let positionAttCard = {
      positionRectCardX: MARGIN,
      positionRectCardY: currentYHeightCursor + 15, 
      positionInfoCardX: MARGIN + (cardWidth / 2),
      positionTitleCardY: currentYHeightCursor + 33, 
      positionAreaHaCardY: currentYHeightCursor + 60, 
    };
  
    let countCardsLine = 1; // Contador de cards por linha

    // Verificar necessidade de uma nova página
    const needPageBreak = () => {
      const cardPositionY = positionAttCard.positionRectCardY + cardHeight + 20; 
      return cardPositionY >= PAGE_HEIGHT 
        ? true
        : false;      
    };

    // Adicionar cabeçalho da seção
    addAlertCrossingHeader();

    intersectionsRestrictionAreas.forEach((ira, i) => {
      // Verifica se é necessário quebrar a página      
      if (needPageBreak()) {
        doc.addPage(); // Adicionar nova página
        positionAttCard.positionRectCardX = MARGIN; // Resetar para margem esquerda
        positionAttCard.positionRectCardY = 36; // Posição inicial para a nova página        
        positionAttCard.positionTitleCardY = positionAttCard.positionRectCardY + 18; 
        positionAttCard.positionAreaHaCardY = positionAttCard.positionRectCardY + 45; 
        countCardsLine = 1; // Reiniciar o contador
      }

      // Adiciona card de cruzamento
      addCardAlertCrossing(ira, positionAttCard);

      // Atualiza posição para cada cartão na linha
      positionAttCard.positionRectCardX += cardWidth;
      positionAttCard.positionInfoCardX += cardWidth;

      // Se o card é o último da lista ou da linha
      if (i === intersectionsRestrictionAreas.length - 1 || countCardsLine % CARDS_PER_LINE === 0) {
        // Redefine posicionamentos
        positionAttCard.positionRectCardX = MARGIN;
        positionAttCard.positionRectCardY += cardHeight + 8;
        positionAttCard.positionInfoCardX = MARGIN + (cardWidth / 2); 
        positionAttCard.positionTitleCardY += cardHeight + 8;
        positionAttCard.positionAreaHaCardY += cardHeight + 8;
        countCardsLine = 1;
      } else {        
          countCardsLine++;        
      }
    });

    // Se houver erro de cruzamento com alguma camada
    if (errorCrossingLayers.length > 0) {
      var texto = "* Obs.: Camada(s) " + errorCrossingLayers.join(", ") + " indisponíveis ou com erro topológico.";
      var linhas = doc.splitTextToSize(texto, 500); // Define caixa para o texto
      var lineHeight = 15; // Altura de cada linha

      // Incrementas linhas na caixa de texto conforme tamanho do conteúdo
      for (let i = 0; i < linhas.length; i++) {        
        doc.text(36, positionAttCard.positionRectCardY + (i * (lineHeight * 0.5)), linhas[i]);
      }

      positionAttCard.positionRectCardY += 40;      
    } else {
      positionAttCard.positionRectCardY += 20;
    }

    // Verifica se é necessário quebrar a página
    if (needPageBreak()) {
      doc.addPage(); // Adicionar nova página     
      positionAttCard.positionRectCardY = 36; // Posição inicial para a nova página             
    } 

    return positionAttCard.positionRectCardY;
  
  }, [intersectionsRestrictionAreas, errorCrossingLayers]);  

  /**
   * Sessão "Atributos das Áreas de Restrição"
   */
  const addAttributesRestrictionAreas = useCallback((doc, positionWriterY) => {      
    
    // Adiciona cabeçalho da seção "Atributos Áreas de Restrição"
    const addAttributesHeader = () => {
      doc.setFontSize(14);
      doc.setTextColor('#3C71DD');    
      doc.text('Atributos das Áreas de Restrição', 36, positionWriterY); 

      doc.setDrawColor('#3C71DD');
      positionWriterY += 4;
      doc.line(36, positionWriterY, 200, positionWriterY);
      positionWriterY += 12;
      
      doc.setFontSize(9);
      doc.setTextColor("#5E5E5E");
    };

    // Desenha caixa onde será apresentada títulos
    // da camada 'Área de restrição' cruzada
    const drawTitleTable = (positionWriterY, aliasLayer) => {
      doc.saveGraphicsState();

      doc.setGState(new doc.GState({
        opacity: 0.1,         
      }));
      doc.setDrawColor('#ffffff');
      doc.setFillColor('#3C71DD');      
      doc.roundedRect(36, positionWriterY, 520, 15, 1, 1, "FD");            
      
      doc.restoreGraphicsState();
      
      doc.text(aliasLayer, 42, positionWriterY+10);
    };

    // Tabela onde serão apresentadas informações do cruzamento
    const buildAttributeTable = () => {
      let tableProps = {};      
      
      // Constroi as tabelas de atributos
      intersectionsRestrictionAreas.forEach((ira) => {              
        if (ira.dataTable.length > 0) {          
          // Ajusta posicionamento do cursor de escrita para
          // próxima página caso esta no final da página corrente
          if (positionWriterY > 780) {
            doc.addPage(); 
            positionWriterY = 40;
          }
          // Título da tabela
          drawTitleTable(positionWriterY, ira.aliasLayer);
          positionWriterY += 15;

          autoTable(doc, {
            startY: positionWriterY,
            margin: {
              top: 36, 
              right: 40, 
              bottom: 36, 
              left: 42
            },
            horizontalPageBreak: false,
            head: ira.columnsLabel,
            headStyles: {
              textColor: [94, 94, 94],
              fillColor: [255, 255, 255],
              border: {top: 0, right: 0, bottom: 2, left: 0},
            },
            body: ira.dataTable,
            bodyStyles: {
              minCellHeight: 18,
              valign: 'bottom',
            },
            theme: 'plain',
            willDrawCell (HookData) {
              if (HookData.section === 'head') {
                doc.setDrawColor(171, 171, 171);
                doc.setLineWidth(0.5);                
                doc.line(
                  HookData.cell.x,
                  HookData.cell.y + HookData.row.height,
                  HookData.cell.x + HookData.cell.width,
                  HookData.cell.y + HookData.row.height
                );
                if (HookData.pageCount > 1) {
                  return false
                }                
              }
            },
            didParseCell: function (HookData) {
              tableProps = HookData.table;
            }
          });

          positionWriterY = tableProps.finalY + 10;
        }

      });
    };

    // Adiciona cabeçalho da seção
    addAttributesHeader();
    
    // Constroi as tabelas de atributos
    buildAttributeTable();

    return positionWriterY;

  }, [intersectionsRestrictionAreas]);

  /**
   * Sessão "Metodologia"
   */
  // const addMethodology = useCallback((doc, positionWriterY) => {  
  //   positionWriterY += 15;

  //   // Ajusta posicionamento do cursor de escrita para
  //   // próxima página caso esta no final da página corrente
  //   if (positionWriterY > 780) {
  //     doc.addPage(); 
  //     positionWriterY = 40;
  //   }
    
  //   // Adiciona cabeçalho da seção "Metodologia"
  //   const addMethodologyHeader = () => {
  //     doc.setFontSize(14);
  //     doc.setTextColor('#3C71DD');    
  //     doc.text('Metodologia', 36, positionWriterY); 

  //     doc.setDrawColor('#3C71DD');
  //     positionWriterY += 4;
  //     doc.line(36, positionWriterY, 200, positionWriterY);
  //     positionWriterY += 15;
      
  //     doc.setFontSize(9);
  //     doc.setTextColor("#5E5E5E");
  //   };

  //   // Adiciona texto da metodologia
  //   const buildMethodology = () => {
  //     doc.text('Donec ultricies nisl egestas viverra varius. Nunc vulputate blandit iaculis. Curabitur nec magna sed elit maxi tristique eu quis nisi. Aenean viverra fermentum sollicitudin. Maecenas sit amet laoreet ligula. Vivamus facilisis ut libero sit amet lacinia. Ut accumsan velit sem, vitae fermentum arcu euismod. Vivamus vulputate nulla ac rhoncus pellentesque. Integer ultricies lacus nec purus faucibus, vitae molestie turpis scelerisque. Proin aliquet ut ex quis interdum. Quisque quis lectus blandit tortor bibendum blandit. Nulla ut tristique ante.', 36, positionWriterY, 
  //       {
  //         maxWidth: 517
  //       }
  //     );
  //     positionWriterY += 40;
  //   };

  //   // Adiciona cabeçalho da seção
  //   addMethodologyHeader();

  //   // Constroi metodologia
  //   buildMethodology();

  //   return positionWriterY;

  // }, []);

  /**
   * Sessão "Metadados"
   */
  // const addMetadata = useCallback((doc, positionWriterY) => {  
  //   positionWriterY += 15;

  //   // Ajusta posicionamento do cursor de escrita para
  //   // próxima página caso esta no final da página corrente
  //   if (positionWriterY > 780) {
  //     doc.addPage(); 
  //     positionWriterY = 40;
  //   }
    
  //   // Adiciona cabeçalho da seção "Metodologia"
  //   const addMetadataHeader = () => {
  //     doc.setFontSize(14);
  //     doc.setTextColor('#3C71DD');    
  //     doc.text('Metadados', 36, positionWriterY); 

  //     doc.setDrawColor('#3C71DD');
  //     positionWriterY += 4;
  //     doc.line(36, positionWriterY, 200, positionWriterY);
  //     positionWriterY += 15;
      
  //     doc.setFontSize(9);
  //     doc.setTextColor("#5E5E5E");
  //   };

  //   // Adiciona informações dos metadados
  //   const buildMetadata = () => {
  //     doc.text('Maecenas sit amet laoreet ligula. Donec ultricies nisl egestas viverra varius. Nunc vulputate blandit iaculis. Curabitur nec magna sed elit maximus tristique eu quis nisi. Aenean viverra fermentum sollicitudin. Uthert accumsan velit sem, vitae fermentum arcu euismod. Vivamus facilisis ut libero sit amet lacinia.', 36, positionWriterY, 
  //       {
  //         maxWidth: 517
  //       }
  //     );
  //     positionWriterY += 40;
  //   };

  //   // Adiciona cabeçalho da seção
  //   addMetadataHeader();

  //   // Constroi metodologia
  //   buildMetadata();

  //   return positionWriterY;

  // }, []);

  /**
   * Adiciona contagem de página no rodape de cada página
   */
  const addCountPages = useCallback((doc) => {  
    let pageCount = doc.internal.getNumberOfPages();    
    for(let i = 0; i < pageCount; i++) {       
      doc.setPage(i);       
        doc.setDrawColor('#3C71DD');
        doc.setLineWidth(0.1);
        doc.line(36, 808, 555, 808);
        var texto = "Este documento não substitui estudos ambientais exigidos. Seu conteúdo é baseado nas fontes indicadas, e o uso das informações é de responsabilidade do usuário. A precisão dos resultados pode variar devido ao sistema considerar valores com apenas duas casas decimais. (ex: 0,00% pode ser resultado de 0,009%).";
        var linhas = doc.splitTextToSize(texto, 500);
        var lineHeight = 15; // Altura de cada linha
        
        for (let i = 0; i < linhas.length; i++) {
            doc.text(36, 820 + (i * lineHeight * 0.5), linhas[i]);
        }
             
        doc.text(538, 820, doc.internal.getCurrentPageInfo().pageNumber + "/" + pageCount);
    }

  }, []);

  /**
   * Constroe Relatorio
   */
  const buildReport = useCallback((doc) => {

    addHeader(doc);
    addComment(doc);  

    getImageMapLocation()
      .then((mapImageLocation) => {          
        return resizeImage(mapImageLocation, 924, 443);
      })
      .then((resizedImage) => {                
        addMapLocation(doc, resizedImage);
      })
      .then(() => {
        return getImageScale();
      })
      .then((imageScale) => {        
        return resizeImage(imageScale, null, null, 0.66);
      })
      .then((resizedImageScale) => {          
        buildScaleMap(doc, resizedImageScale);
      })
      .then(() => {
        // verificar o tamanho da pagina e quebrar dinamicamente o conteudo doc.breakPage();
        return addAlertCrossings(doc);
      })
      .then((positionWriterY) => {        
        return addAttributesRestrictionAreas(doc, positionWriterY);
      })
      // .then((positionWriterY) => {
      //   return addMethodology(doc, positionWriterY);
      // })
      // .then((positionWriterY) => {
      //   addMetadata(doc, positionWriterY);
      // })
      .then(() => {
        addCountPages(doc);
      })
      .finally(() => {        
        doc.output('dataurlnewwindow'); 
        setLoading(false);        
      });

  }, [
    addHeader, 
    addComment, 
    getImageMapLocation, 
    resizeImage, 
    addMapLocation,
    buildScaleMap,
    addAlertCrossings, 
    addAttributesRestrictionAreas,    
    addCountPages
  ]);

  /**
   * Adiciona camadas selecionadas do geoserviço ao mapa
   */
  const generatePrint = useCallback(() => {
    setLoading(true);

    const doc = new jsPDF({
      orientation: 'p',
      unit: 'px',
      format: [842, 595],
      compress: false,
      autoSize: false,
      printHeaders: false,
    });

    doc.setProperties({
      title: 'Relatório Preliminar de Análise Ambiental',
    });

    // Estilos
    doc.setTextColor("#5E5E5E");
    doc.setDrawColor("#5E5E5E");
    doc.setFillColor("#FFFFFF");
    doc.setFontSize(16);
    doc.setFont("Helvetica", "normal");
    
    buildReport(doc);    
    
  }, [buildReport]);

  /**
   * Obtém dados para geração do relatório
   */
  useEffect(() => {    

    // Obtém coordenadas da camada de entrada
    const getGeometryCoordinatesInputLayer = () => {        
      return inputLayer.dataType === 'Polygon'
              ? inputLayer.leafletLayer.getLayers()[0].feature.geometry.coordinates[0]
              : inputLayer.dataType === 'LineString'
                ? inputLayer.leafletLayer.getLayers()[0].feature.geometry.coordinates
                : [inputLayer.leafletLayer.getLayers()[0].feature.geometry.coordinates];
    };

    // Realiza requisições nas camadas 'Áreas de Restrição' considerando
    // interseção com geometria da camada de entrada
    const getIntersectRestrictionAreas = async () => {   
      // let geoJsonInputLayer = inputLayer.leafletLayer.toGeoJSON();  
      // let inputLayerWithCRS = {
      //   type: geoJsonInputLayer.type,
      //   crs:{
      //     type:"name",
      //     properties:{
      //       name:"EPSG:3857"
      //     }
      //   },
      //   features: geoJsonInputLayer.features
      // }      
      let arrPromisesOutputFeatureCollections = [];
      // let config = {
      //   headers: {'Content-Type': 'text/xml'}
      // }; 

      dataProtectedAreasReport.configuracao.selectedLayers.forEach((lyr) => {  
        // Define qual mecanismo de interseção sera adotado para a camada     
        //   lyr.geoserverWorkspace,
        //   lyr.geoserverName,
        //   inputLayerWithCRS
        // ));
        // if (lyr.geometryType === 'Polygon' || lyr.geometryType === 'LineString') {
        //   arrPromisesOutputFeatureCollections.push(new Promise((resolve, reject) => {
        //     return axios.post(
        //       `${process.env.REACT_APP_GEO_SERVER_HOST}/ows`, 
        //       bodyXmlIntersectionFeatureCollection(
        //         lyr.geoserverWorkspace,
        //         lyr.geoserverName,
        //         inputLayerWithCRS
        //       ), 
        //       config
        //     )
        //     .then((response) => {                       
        //       return resolve({
        //         aliasLayer: lyr.alias,
        //         geoserverName: lyr.geoserverName,
        //         data: response.data,
        //         geometryType: lyr.geometryType,
        //         attributes: lyr.attributes,
        //       });                
        //     })
        //     .catch(() => {
        //       return resolve({
        //         aliasLayer: lyr.alias,
        //         geoserverName: lyr.geoserverName,
        //         data: null,
        //         geometryType: lyr.geometryType,
        //         attributes: lyr.attributes,
        //       });
        //     });          
        //   }));
        // } else {
          let geometryTypeInputLayer = inputLayer.dataType.toUpperCase();
          let geometryCoordinates = getGeometryCoordinatesInputLayer();
          let withParentheses = inputLayer.dataType === 'Polygon' ? true : false;      
          let cqlFilter = `INTERSECTS(geom, ${geometryTypeInputLayer}(${Coord.convertCoordinatesToWKT(
            geometryCoordinates,
            withParentheses
          )}))`;

          let currentLayer = new Layer(
            null,
            'interna',
            null,
            lyr.alias,
            null,
            lyr.geoserverName,
            lyr.geoserverWorkspace,
            null,
            null
          );
          let params = {
            version: '1.0.0',
            request: 'GetFeature',
            typeName: currentLayer.getLayerNameParam(),
            outputFormat: 'application/json',          
          };
          
          arrPromisesOutputFeatureCollections.push(
            new Promise((resolve, reject) => {       
  
              return fetch(
                    `${currentLayer.getFullServiceLink('WFS', params)}`, 
                    {
                      headers: {                      
                        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',                      
                      },
                      method: 'POST',                    
                      body: new URLSearchParams({cql_filter: cqlFilter})
                    })
                    .then((response) => response.json())
                    .then(
                      (data) => {                      
                        return resolve({
                          aliasLayer: lyr.alias,
                          geoserverName: lyr.geoserverName,
                          data: data,
                          geometryType: lyr.geometryType,
                          attributes: lyr.attributes,
                        });
                      }
                    )
                    .catch(() => {
                      return resolve({
                        aliasLayer: lyr.alias,
                        geoserverName: lyr.geoserverName,
                        data: null,
                        geometryType: lyr.geometryType,
                        attributes: lyr.attributes,
                      });
                    });
  
            })
          );  
        // }        

      });

      return Promise.all(arrPromisesOutputFeatureCollections);

    };

    // Define unidade de medida a ser apresentada
    const defineUnitOfMeasure = (inputLayerGeometryType, restrictionAreaGeometryType) => {
      let unitOfMeasure = null;

      switch (inputLayerGeometryType) {
        case 'Polygon':
          if (['Polygon', 'MultiPolygon', 'Geometry'].includes(restrictionAreaGeometryType)) {
            unitOfMeasure = 'area';
          } else if (['LineString', 'MultiLineString'].includes(restrictionAreaGeometryType)) {
            unitOfMeasure = 'length';
          } else {
            unitOfMeasure = 'boolean';
          }          
          break;          
        case 'LineString':
          if (['Polygon', 'MultiPolygon'].includes(restrictionAreaGeometryType)) {
            unitOfMeasure = 'length';
          } else {
            unitOfMeasure = 'boolean';
          }          
          break;
        default:          
          unitOfMeasure = 'boolean';          
      }

      return unitOfMeasure;
    };

    // Obtém nome das propriedade da camada
    // 'Área de Restrição' cruzada
    const getPropertiesLabelsLayer = (ira, canAddPercentage, canAddHectare) => {
      let labels = [];
      let propertiesLabelsLayer = [];      
      let featuresRestrictionAreas = ira.data.features;

      if (featuresRestrictionAreas.length > 0) {
        if (ira.attributes.length > 0) {          
          labels = [...ira.attributes];
        } else {          
          labels = Object.keys(featuresRestrictionAreas[0].properties);
        }

        if (canAddPercentage) {
          labels.push('% de cobertura');          
        }

        if (canAddHectare) {
          labels.push('Área (ha)');          
        }
      }      

      propertiesLabelsLayer.push(labels);
      
      return propertiesLabelsLayer;
    };

    // Obtém valores das propriedade da camada
    // 'Área de Restrição' cruzada
    const getPropertiesValuesLayer = (ira, fra, propertiesValuesLayer, calculatePercentage, calculateHectare, areaIntersectionFeature) => {
      let arrPropsValuesFeature = []; 
      let valueProp;
      let percentageIntersect;
      let hectareIntersect;
      let percentageValue = 0;
      let hectareValue = 0;
      
      // Se houve definição de atributos específicos para
      // serem exibidos na tabela de atributos, obtém 
      // apenas os valores dos selecionados. Senão 
      // obtém todos.
      if (ira.attributes.length > 0) {        
        ira.attributes.forEach((att) => {
          // Se obtenção do valor pelo atributo for 'undefined' infere que
          // cruzamento foi realizado através do mecanismo WPS. O mesmo
          // altera o labels dos atributos da feição resultante da interseção, onde
          // os atributos  da camada interna cruzada recebem como prefixo
          // o nome original da camada no Geoserver (geoserverName) e os atributos
          // da camada de entrada recebem o prefixo 'feature'. Ambos prefixos
          // são separados por underline 
          valueProp = fra.properties[att] === undefined
                        ? fra.properties[`${ira.geoserverName}_${att}`]
                        : fra.properties[att];          
          arrPropsValuesFeature.push(valueProp);
        });        
      } else {
        arrPropsValuesFeature = Object.values(fra.properties);        
      }      

      // Adiciona valor da porcentagem da área da camada 
      // "Área de Restrição" que foi interseccionada
      // pela feição da camada de entrada
      if (calculatePercentage) { 
        // Verifica se a feição possui o atributo 'percentageA' disponível quando
        // operação de interseção realizado pelo mecanismo WPS      
        percentageIntersect = fra.properties.percentageA 
                                ? fra.properties.percentageA < 0
                                  ? 0
                                  : fra.properties.percentageA
                                : areaIntersectionFeature / measureArea(fra.geometry.coordinates, true);        
        percentageValue = (percentageIntersect * 100).toFixed(2);
        arrPropsValuesFeature.push(percentageValue + " %");
      }

      // Adiciona valor da área em hectare da camada 
      // "Área de Restrição" que foi interseccionada
      // pela feição da camada de entrada
      if (calculateHectare) {         
        hectareIntersect = areaIntersectionFeature / 10000;        
        hectareValue = hectareIntersect.toFixed(2);
        arrPropsValuesFeature.push(hectareValue);
      }

      propertiesValuesLayer.push(arrPropsValuesFeature);
      arrPropsValuesFeature = [];

      return propertiesValuesLayer;
    };

    // Mantém valores das interseções
    const calculateIntersections = async (arrIntersectedRestrictionAreas) => {
      let intersections = [];
      let errorsCrossingLayers = [];
      let unitOfMeasure = null;      

      arrIntersectedRestrictionAreas.forEach((ira) => {
        if (typeof ira.data === 'object' && ira.data !== null) {
          let featureCoodinates;
          let propertiesLabelsLayer = [];
          let propertiesValuesLayer = [];
          let measureAreaIntersectionFeature = 0;
          let canAddPercentage = false;
          let canAddHectare = false;
          let hasPointOfIntersect = false;          
          let totalCoverageIntersectedFeature = 0;
          let valueIntersection = '';                
          let featuresRestrictionAreas = ira.data.features;        

          featuresRestrictionAreas.forEach((fra) => {
            // garante que a feature tenha apenas um par de coordenadas para realização do cálculo de área
            // OBS.: Algumas camadas possuem coordenada 'Z' referente a altura
            fra = turf.truncate(fra, { coordinates: 2 });
            if (inputLayer.dataType === 'Polygon') {              
              if (fra.geometry.type === 'Polygon' || fra.geometry.type === 'MultiPolygon') {
                // Camada do tipo 'Geometry' não são operadas pelo mecanismo de interseção WPS,
                // portanto a feição interseccionada é obtida na integra (e não apenas a interseção como no WPS)
                // e deve ser realizada operação com a biblioteca turf para obter apenas a interseção
                // if(ira.geometryType === 'Geometry') {                  
                  let intersectionFeature = turf.intersect(
                    fra,
                    inputLayer.leafletLayer.getLayers()[0].feature
                  );                          
                  featureCoodinates = intersectionFeature?.geometry.coordinates;
                // }

                if (featureCoodinates) {
                  if (featureCoodinates.length > 1) {
                    featureCoodinates.forEach(function(coords) {
                      measureAreaIntersectionFeature += measureArea(coords, true);
                    });
                  } else {
                    measureAreaIntersectionFeature = measureArea(featureCoodinates, true);
                  }
                  
                  totalCoverageIntersectedFeature = totalCoverageIntersectedFeature + measureAreaIntersectionFeature;                            
                }

                canAddPercentage = true;      
                canAddHectare = true; 
                
              } else {
                if (fra.geometry.type === 'LineString' || fra.geometry.type === 'MultiLineString') {                  
                  totalCoverageIntersectedFeature = totalCoverageIntersectedFeature + measureLength(fra.geometry.coordinates, true);
                } else {                     
                  hasPointOfIntersect = true;
                }
              }            
            } else {  
              if (inputLayer.dataType === 'LineString') {
                if (fra.geometry.type === 'Polygon' || fra.geometry.type === 'MultiPolygon') {
                  let fraPolygon = {};
                  // Transforma a feição multipolígono da camada Área de restrição
                  // em uma feição do tipo polígono para verificar se a feição de entrada (linha)
                  // está totalmente contida na mesma
                  fraPolygon = turf.flatten(fra).features[0];                
                  // Separa a feição de entrada (linha) em "pedaços" definidos pela 
                  // interseção com a feição intersecionada da Área de Restrição
                  let lineSplited = turf.lineSplit(inputLayer.leafletLayer.getLayers()[0].feature, fraPolygon);

                  if (lineSplited.features.length > 0) {
                    // Reliza um laço em cada "pedaço" da feição de entrada (linha)            
                    lineSplited.features.forEach((lineFeature) => {
                      // Verifica se o "pedaço" da feição de entrada (linha)
                      // esta intercecionando totalmente (contida) na feição 
                      // da Área de Restrição para posteriormente obter o comprimento
                      // da feição (linha) intercecionada
                      if (turf.booleanContains(fraPolygon, lineFeature)) {                  
                        totalCoverageIntersectedFeature =
                          totalCoverageIntersectedFeature +
                          measureLength(lineFeature.geometry.coordinates, true);                  
                      }
                    });
                  } else {
                    totalCoverageIntersectedFeature =
                          totalCoverageIntersectedFeature +
                          measureLength(inputLayer.leafletLayer.getLayers()[0].feature.geometry.coordinates, true);
                  }
                } else {                
                  hasPointOfIntersect = true;                
                }
              } else { // Camada de entrada eh do tipo Ponto             
                hasPointOfIntersect = true;
              }
            }
            
            propertiesValuesLayer = getPropertiesValuesLayer(ira, fra, propertiesValuesLayer, canAddPercentage, canAddHectare, measureAreaIntersectionFeature);
                        
          });

          // Obtém os labels das colunas da tabela de atributos
          propertiesLabelsLayer = getPropertiesLabelsLayer(ira, canAddPercentage, canAddHectare);   
          

          // Obtém unidade de medida
          unitOfMeasure = defineUnitOfMeasure(inputLayer.dataType, ira.geometryType);
          switch (unitOfMeasure) {
            case 'area':
              valueIntersection = totalCoverageIntersectedFeature 
                                  ? parseFloat((totalCoverageIntersectedFeature / 10000).toFixed(2)).toLocaleString('pt-br') + " ha"
                                  : '0,00 ha';
              break;          
            case 'length':
              valueIntersection = totalCoverageIntersectedFeature 
                                  ? parseFloat((totalCoverageIntersectedFeature / 1000).toFixed(2)).toLocaleString('pt-br') + " km"
                                  : '0,00 km';
              break;
            default:
              valueIntersection = hasPointOfIntersect 
                                  ? 'Sim'
                                  : 'Não';
          }

          intersections.push({
            aliasLayer: ira.aliasLayer,          
            valueIntersection: valueIntersection,
            columnsLabel: propertiesLabelsLayer,
            dataTable: propertiesValuesLayer,
          });
        } else {
          intersections.push({
            aliasLayer: ira.aliasLayer,          
            valueIntersection: '-',
            columnsLabel: [[]],
            dataTable: [],
          });
          errorsCrossingLayers.push(ira.aliasLayer);
          setErrorCrossingLayers(errorsCrossingLayers);
        }
                
      });

      setIntersectionsRestrictionAreas(intersections);
      return intersections;
    };
    
    if (
      inputLayer && 
      activeReport && 
      !crossingIsRunning && 
      !intersectionsRestrictionAreas.length
      ) {
        setCrossingIsRunning(true);
        setLoading(true);
        
        // Obtém as interseções da camada de entrada 
        // com as camadas Áreas de Restrição
        getIntersectRestrictionAreas()
          .then((arrIntersectedRestrictionAreas) => {               
            // Calcula área de interseção da camada de entrada 
            // com as camadas intersectadas
            return calculateIntersections(arrIntersectedRestrictionAreas);
          })
          .then((intersections) => {    
            let intersectionWithData = intersections.find((i) => i.dataTable.length > 0);          
            if (intersectionWithData === undefined) { 
              let closeReport = true;            
              geoConfirm({              
                message: 'Não foi encontrada nenhuma sobreposição. Ainda assim deseja gerar o relatório?',
                callback: (confirmed) => {                
                  if (confirmed) closeReport = false;
                },
                finallyCallback: () => {                
                  if (closeReport) onClose(true);
                },
              });            
            }                        
          })          
          .catch((error) => {            
            geoAlert({
              message: 'Erro ao realizar cruzamento com as camadas de restrição ambiental.',
            });
            onClose(true);
          })
          .finally(() => {
            setCrossingIsRunning(false);
            setLoading(false); 
          });
    }

  }, [inputLayer, crossingIsRunning, activeReport, setErrorCrossingLayers, setIntersectionsRestrictionAreas, intersectionsRestrictionAreas, onClose, dataProtectedAreasReport.configuracao.selectedLayers]);

  /**
   * Define altura e largura do mapa na configuração
   * e na impressão conforme seleção da grade de coordenadas
   */
  useEffect(() => {
    setMaxWidthImg(maxInitialWidthMapPrint);
    setMaxHeightImg(maxInitialHeightMapPrint);
  }, [maxWidthImg]);

  /**
   * Inicia impressão
   */
  useEffect(() => {
    if (startPrint) {
      generatePrint();
      setStartPrint(false);
    }
  }, [startPrint, generatePrint]);

  useEffect(() => {
    // Constroi mapa de localização
    const buildMapLocation = () => {

      let containerMap = L.DomUtil.get('map-location-report');
      if(containerMap != null){
        containerMap._leaflet_id = null;
      }
      
      let mapLocation = L.map('map-location-report', {
        center: [
          inputLayer.leafletLayer.getBounds().getCenter().lat, 
          inputLayer.leafletLayer.getBounds().getCenter().lng
        ],
        // Define zoom do mapa de localiação do preview
        // igual ao zoom do mapa original da aplicação
        zoom: map._zoom, 
        // Desabilita controle de zoom
        zoomControl: false,
        preferCanvas: true,
        // Define zoom máximo 
        maxZoom: 16,
      });    
      setMapReport(mapLocation);
      // Define enquadramento do mapa de localização do preview
      // igual de acordo com o bound box da geometria da camada de entrada
      mapLocation.fitBounds(inputLayer.leafletLayer.getBounds());
      // Desabilita todas as interações de movimentação/interação com o mapa;
      mapLocation._handlers.forEach(function(handler) {
        handler.disable();  
      });
      mapLocation.pm.setLang('pt_br');
      mapLocation.pm.setGlobalOptions({
        tooltips: false,
      });

      // Cria overlay onde serão adicionadas a(s) camada(s)
      mapLocation.createPane('mixedPaneReport');
      mapLocation.getPane('mixedPaneReport').style.zIndex = 300;

      // Adiciona minimapa de referência
      let baseMapMinimap = new L.TileLayer(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          minZoom: 4,
          maxZoom: 4,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
        }
      );

      let lMiniMap = new LeafletMiniMap(baseMapMinimap, {
        width: 120,
        height: 120,
        toggleDisplay: false,
        autoToggleDisplay: false,
        minimized: false,
        zoomLevelFixed: 4,
        centerFixed: [-13.43787561, -41.98166245],        
        aimingRectOptions: {
          lineCap: 'round',
          lineJoin: 'round',
          className: 'retangulo-minimap-report',
        },
      });

      lMiniMap.addTo(mapLocation);
      lMiniMap._miniMap.doubleClickZoom.disable();

      return mapLocation;
    };

    // Adiciona mapa base
    const addBaseMap = (mapLocation) => {
      // Obtém mapa base ativo no mapa principal da aplicação
      // let baseMapMapPrint = basemaps.find((basemap) => 
      //   basemap.active
      // );
      
      // Adiciona mapa base obtido no mapa de localização
      // L.tileLayer(baseMapMapPrint.layer._url, {          
      //   attribution: baseMapMapPrint.layer.options.attribution
      // }).addTo(mapLocation); 
      L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}", {          
        attribution: "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community testrer"
      }).addTo(mapLocation); 
    };

    // Adiciona mapa base
    const addInputLayerOnLocationMap = (mapLocation) => {
      // Obtém objeto layer leaflet da camada de entrada no formato GeoJSON
      let geoJsonInputLayer = inputLayer.leafletLayer.toGeoJSON();      
      // Obtém estilização da camada de entrada
      let layerStyle = {
        ...inputLayer.layerStyle,
        opacity: inputLayer.layerStyle.opacity,            
        fillOpacity: inputLayer.layerStyle.fillOpacity,
      };
      // Define overlay onde a camada será renderizada
      const customRender = L.canvas({ pane: 'mixedPaneReport'});                 
      // Configura o options
      let options = {
        pane: 'mixedPaneReport',
        renderer: customRender,
        style: function (feature) {
          if (inputLayer.classList.length > 0) {
            let featureStyle = inputLayer.classList.find((c) => 
              c.value === feature.properties[inputLayer.classColumn]
            );
            
            if (featureStyle) {
              layerStyle = {
                ...layerStyle,
                color: featureStyle.simbology.fillColor,      
                fillColor: featureStyle.simbology.fillColor, 
              }
            }
          }
          return layerStyle;
        },            
      };
  
      // Garante estilização para camadas com geometrias do tipo ponto
      if (inputLayer.dataType === 'Point' || inputLayer.dataType === 'MultiPoint') {
        layerStyle.fillOpacity = layerStyle.opacity
        options = {
          ...options,
          pointToLayer: function (feature, latlng) {
            return L.circleMarker(latlng, {
              pane: 'mixedPanePrint',
              ...layerStyle,
              renderer: customRender,
            });
          },
        };
      }      
      
      let newLayerToMapPrint = L.geoJSON(geoJsonInputLayer, options);
      newLayerToMapPrint.addTo(mapLocation);
    };
    
    if (activeReport && inputLayer) {      
      // Constroi mapa de localização
      let mapLocation = buildMapLocation();
      // Adiciona mapa base
      addBaseMap(mapLocation);
      // Adiciona camada de entrada no mapa de localização
      addInputLayerOnLocationMap(mapLocation);   
    }    

  }, [activeReport, inputLayer, map, setMapReport, basemaps]);

  return (
    <Wrap widthMap={maxWidthImg} heightMap={maxHeightImg}>
      {loading && (
        <div className="loader">          
          <ReportRestrictionAreasLoader open={loading} />
        </div>
      )}      
      <div
        title="Visualizar PDF"
        style={{
          cursor: 'pointer',
        }}
        onClick={(e) => {
            setStartPrint(true);          
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="21"
          viewBox="0 0 18 21"
          fill="none"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.99877 0.609375L1.62891 5.64386V8.21427H2.70189V6.38011H6.77984V1.68267H15.3482V8.21427H16.4215V0.609375H5.99877Z"
            fill="#5E6366"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.70093 16.0549H15.3491V19.5348L2.70093 19.5225V16.0549ZM11.6379 10.4287H14.6722V11.1734H12.5304V12.1429H14.4043V12.8927H12.5304V14.689H11.6379V10.4287ZM7.27687 10.4287H8.92547C10.0581 10.4287 10.8799 11.3161 10.8997 12.5143C10.9196 13.6138 10.2818 14.689 9.06054 14.689H7.27687V10.4287ZM3.38006 10.4287H5.26061C6.0199 10.4287 6.62645 11.0071 6.62645 11.8093C6.62645 12.5756 6.06093 13.1427 5.26061 13.1427H4.27252V14.6893H3.38006V10.4287ZM0.398438 9.0625V16.0545H1.62952V20.5942L16.4224 20.6087V16.0549H17.6535V9.0625H0.398438Z"
            fill="#5E6366"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M4.27344 11.168V12.4208H5.12014C5.59194 12.4208 5.82989 12.1807 5.84472 11.7846C5.85924 11.3441 5.47644 11.168 5.12014 11.168H4.27344Z"
            fill="#5E6366"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.14453 13.9653H8.88236C9.63534 13.9653 9.99353 13.3158 9.99226 12.5158C9.98879 11.73 9.67006 11.168 8.80505 11.168H8.14453V13.9653Z"
            fill="#5E6366"
          />
        </svg>
      </div>
    </Wrap>
  );
};

export default ProtectedAreasReportView;
